export const termsAndConditionUrl = 'https://growthval.webflow.io/privacy-policy';
export const subscriptionCost = 79; // £79.00
